import { useCanManageOrgSettings } from '#pplx/frontend/apps/ask/organization/hooks/useCanManageOrgSettings.js';
import { useUserOrgData } from '#pplx/frontend/apps/ask/organization/hooks/useUserOrgData.js';
import { DEFAULT_RELEASE_PHASE, coerceReleasePhase, } from '#pplx/frontend/apps/ask/settings/v2/releasePhases.js';
import { useLocalUserSettings } from '#pplx/frontend/apps/ask/user-settings/getLocalUserSettings.js';
import { useUserSettingsQuery } from '#pplx/frontend/apps/ask/user-settings/hooks/useUserSettingsQuery.js';
export function useUserReleasePhase(reason) {
    const { organization } = useUserOrgData({ reason });
    const isAdmin = useCanManageOrgSettings();
    const [isOverrideOn, setIsOverrideOn] = useLocalUserSettings('isReleasePhaseOverridden', false);
    const adminOverride = isAdmin && isOverrideOn;
    const { releasePhase } = useUserSettingsQuery({ reason, enabled: adminOverride });
    const isInOrg = organization != null;
    const orgDefault = coerceReleasePhase(organization?.settings?.release_phase_default);
    const userPhase = coerceReleasePhase(releasePhase);
    let effectivePhase = DEFAULT_RELEASE_PHASE;
    if (isInOrg) {
        effectivePhase = adminOverride ? userPhase : orgDefault;
    }
    return {
        effectivePhase,
        orgDefault,
        userPhase,
        isAdmin,
        isInOrg,
        isOverrideOn,
        setIsOverrideOn,
    };
}
//# sourceMappingURL=useUserReleasePhase.js.map